var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompression(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d1fc1e2227"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 9 L 18 9 L 18 55 L 6 55 Z M 6 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c4b4374a6e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.152344 54.925781 L 5.640625 54.179688 L 13.113281 9.089844 L 17.621094 9.835938 Z M 10.152344 54.925781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a166ffb48a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.023438 54.574219 C 7.460938 54.480469 6.957031 54.164062 6.621094 53.699219 C 6.289062 53.234375 6.15625 52.65625 6.25 52.09375 L 12.972656 11.503906 C 13.066406 10.9375 13.378906 10.433594 13.847656 10.101562 C 14.3125 9.769531 14.890625 9.632812 15.453125 9.726562 C 16.019531 9.820312 16.523438 10.132812 16.855469 10.597656 C 17.1875 11.066406 17.320312 11.644531 17.226562 12.207031 L 10.503906 52.796875 C 10.410156 53.363281 10.097656 53.867188 9.632812 54.199219 C 9.167969 54.53125 8.585938 54.667969 8.023438 54.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be08a81ea5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.898438 7.5 L 69.023438 7.5 L 69.023438 11.25 L 5.898438 11.25 Z M 5.898438 7.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2caa73a07"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17 9 L 29 9 L 29 55 L 17 55 Z M 17 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4e0eda4584"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.835938 54.925781 L 17.328125 54.179688 L 24.796875 9.089844 L 29.304688 9.835938 Z M 21.835938 54.925781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a0d48a565f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.707031 54.574219 C 19.144531 54.480469 18.640625 54.164062 18.308594 53.699219 C 17.972656 53.234375 17.839844 52.65625 17.933594 52.09375 L 24.660156 11.503906 C 24.75 10.9375 25.066406 10.433594 25.53125 10.101562 C 25.996094 9.769531 26.574219 9.632812 27.136719 9.726562 C 27.703125 9.820312 28.207031 10.132812 28.539062 10.597656 C 28.871094 11.066406 29.007812 11.644531 28.914062 12.207031 L 22.1875 52.796875 C 22.09375 53.363281 21.78125 53.867188 21.316406 54.199219 C 20.851562 54.53125 20.273438 54.667969 19.707031 54.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "881d1c6f7e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35.300781 9.421875 L 39.871094 9.421875 L 39.871094 55 L 35.300781 55 Z M 35.300781 9.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a34550f353"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.460938 9.421875 C 38.03125 9.421875 38.578125 9.648438 38.984375 10.054688 C 39.386719 10.457031 39.617188 11.007812 39.617188 11.578125 L 39.617188 52.722656 C 39.617188 53.292969 39.386719 53.84375 38.984375 54.246094 C 38.578125 54.652344 38.03125 54.878906 37.460938 54.878906 C 36.886719 54.878906 36.339844 54.652344 35.933594 54.246094 C 35.53125 53.84375 35.300781 53.292969 35.300781 52.722656 L 35.300781 11.578125 C 35.300781 11.007812 35.53125 10.457031 35.933594 10.054688 C 36.339844 9.648438 36.886719 9.421875 37.460938 9.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5cbcaff23d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44 9 L 57 9 L 57 55 L 44 55 Z M 44 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "792afbecf6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.625 10.183594 L 49.121094 9.359375 L 57.359375 54.3125 L 52.863281 55.136719 Z M 44.625 10.183594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b49650293d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46.746094 9.792969 C 47.308594 9.691406 47.890625 9.816406 48.363281 10.140625 C 48.832031 10.464844 49.15625 10.964844 49.257812 11.527344 L 56.671875 51.996094 C 56.777344 52.558594 56.652344 53.140625 56.324219 53.609375 C 56 54.082031 55.503906 54.402344 54.941406 54.507812 C 54.378906 54.609375 53.796875 54.484375 53.324219 54.160156 C 52.855469 53.835938 52.53125 53.335938 52.429688 52.773438 L 45.015625 12.304688 C 44.910156 11.742188 45.035156 11.160156 45.363281 10.691406 C 45.6875 10.21875 46.183594 9.898438 46.746094 9.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c1e934ac7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56 9 L 69 9 L 69 55 L 56 55 Z M 56 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d796b14b98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.585938 10.152344 L 61.082031 9.328125 L 69.320312 54.285156 L 64.824219 55.105469 Z M 56.585938 10.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "83c704e2cf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 58.707031 9.761719 C 59.269531 9.660156 59.851562 9.785156 60.320312 10.109375 C 60.792969 10.433594 61.113281 10.933594 61.21875 11.496094 L 68.632812 51.96875 C 68.734375 52.53125 68.613281 53.109375 68.285156 53.582031 C 67.960938 54.050781 67.464844 54.375 66.898438 54.476562 C 66.335938 54.578125 65.757812 54.457031 65.285156 54.128906 C 64.816406 53.804688 64.492188 53.308594 64.390625 52.746094 L 56.976562 12.273438 C 56.871094 11.710938 56.996094 11.128906 57.320312 10.660156 C 57.648438 10.1875 58.144531 9.867188 58.707031 9.761719 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d1fc1e2227)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4b4374a6e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a166ffb48a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 10.152344 54.925781 L 5.988281 54.234375 L 13.402344 9.496094 L 17.5625 10.183594 Z M 10.152344 54.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be08a81ea5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 5.898438 7.5 L 69.179688 7.5 L 69.179688 11.367188 L 5.898438 11.367188 Z M 5.898438 7.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b2caa73a07)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4e0eda4584)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a0d48a565f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.835938 54.925781 L 17.675781 54.234375 L 25.085938 9.496094 L 29.25 10.183594 Z M 21.835938 54.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#881d1c6f7e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a34550f353)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 35.300781 9.421875 L 39.519531 9.421875 L 39.519531 54.773438 L 35.300781 54.773438 Z M 35.300781 9.421875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5cbcaff23d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#792afbecf6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b49650293d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 44.625 10.183594 L 48.777344 9.421875 L 56.949219 54.03125 L 52.800781 54.792969 Z M 44.625 10.183594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c1e934ac7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d796b14b98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#83c704e2cf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 56.585938 10.152344 L 60.738281 9.390625 L 68.910156 54 L 64.761719 54.761719 Z M 56.585938 10.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompression);
export default __webpack_public_path__ + "static/media/Compression.62cf56f2469de67ba6a2ca6da8a7259b.svg";
export { ForwardRef as ReactComponent };